import React, { Component } from "react";
import { LinkType } from "../../../common/commonServices";
import Button from '@material-ui/core/Button';
import { toast } from 'react-toastify';
import CircularProgress from './../../../../components/CircularProgress';
import PaginationComponent from './../../../common/Pagination';
import { GetOtherInternalNotes, AddQuestion, InsertUpdateOtherInternalNotes } from "../../../../appRedux/actions/QuestionCommentsAction";
import { UpdateAccountsCommentNotes } from "../../../../appRedux/actions/IncomeStatementAction";
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import Textarea from 'antd/lib/input/TextArea';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import ClearIcon from '@material-ui/icons/Clear';

class OtherInternalNotes extends Component {
  constructor(props) {
    super(props);
    this.state = {
      parantData: this.props.location.state ? this.props.location.state : null,
      QuesData: [],
      companyId: 0,
      PageNo: 1,
      PageSize: 10,
      ColorCode: "#46b29d",
      loading: false,
      IsClosed: false,
      stSearch: null,
      TotalRecords: 0,
      isClosedRequest: false,
      editIndex: -1,
      isAddModal: false,
      commentMessage: '',
      accountId: 0
    }
  }


  ChangePageSize = (size) => {
    this.setState({
      loading: true, PageSize: parseInt(size), PageNo: 1
    }, () => {
      this.getOtherInternalNotes();
    });
  }

  ChangePage = (page) => {
    this.setState({
      loading: true, PageNo: page
    }, () => {
      this.getOtherInternalNotes();
    });
  }

  ///////Commented for remove the Search functionality as pr client request
  // ChangeSearch = (e) => {
  //   this.setState({ stSearch: e.target.value })
  // }

  // OnSearchClick = () => {
  //   this.setState({
  //     loading: true, PageNo: 1
  //   }, () => {
  //     this.getOtherInternalNotes();
  //   });
  // };

  onResolvedClick = (e) => {
    //this.setState({ IsClosed: e.target.checked, loading: true }, () => { this.GetQuestions() })
  }

  componentDidMount() {
    let user = JSON.parse(localStorage.getItem('userData'));
    this.setState({
      companyId: user.companyId,
      loading: true
    }, () => {
      this.getOtherInternalNotes();
    });
  }

  componentWillReceiveProps(nextprops) {
    if (this.props.OtherInternalNotesData !== nextprops.OtherInternalNotesData) {
      if (nextprops.OtherInternalNotesData && nextprops.OtherInternalNotesData.transactionStatus === 0) {
        let total = 0;
        if (nextprops.OtherInternalNotesData.returnObject && nextprops.OtherInternalNotesData.returnObject.length > 0) {
          total = nextprops.OtherInternalNotesData.returnObject[0].totalRows || 0;
        }
        // Ensure current page is still valid after deletions/updates
        const pageSize = this.state.PageSize || 10;
        const maxPage = total > 0 ? Math.ceil(total / pageSize) : 1;
        const currentPage = this.state.PageNo || 1;
        const needAdjustPage = currentPage > maxPage;

        this.setState({
          loading: false,
          QuesData: nextprops.OtherInternalNotesData.returnObject || [],
          TotalRecords: total,
          PageNo: needAdjustPage ? maxPage : currentPage
        }, () => {
          if (needAdjustPage) {
            // If the current page is beyond the last page, fetch the last valid page
            this.setState({ loading: true }, () => {
              this.getOtherInternalNotes();
            });
          }
        });
      }
      else {
        this.setState({ loading: false }, () => {
          if (nextprops.OtherInternalNotesData && nextprops.OtherInternalNotesData.resultMsg) {
            toast.error(`${nextprops.OtherInternalNotesData.resultMsg}`);
          }
        });
      }
    }
  }

  getOtherInternalNotes() {
    let st = this.state;
    let body = {
      "companyID": st.companyId,
      "search": st.stSearch,
      "pageNumber": st.PageNo,
      "pageSize": st.PageSize
    }
    this.props.GetOtherInternalNotes(body);
  }

  isExpand = (j, data) => {
    this.setState({ editIndex: j, commentMessage: data.commentMessage, accountId: data.accountId });
  }

  UpdateInternalNote = (data) => {
    this.setState({ loading: true }, () => {
      if (data.sortCategory === 3) {
        const body = {
          CommentId: data.commentId,
          Comments: this.state.commentMessage,
          CompanyId: this.state.companyId
        };
        this.props.InsertUpdateOtherInternalNotes(body);
      } else {
        const notesBody = {
          AccountId: data.accountId,
          Comments: this.state.commentMessage ? this.state.commentMessage : ""
        };
        this.props.UpdateAccountsCommentNotes(notesBody);
      }

      setTimeout(() => {
        toast.success("Notes updated successfully.");
        this.setState({ editIndex: -1, commentMessage: '', accountId: 0 });
        this.getOtherInternalNotes();
      }, 3000);
    });
  }

  onRowCancelClick = () => {
    this.setState({ editIndex: -1, commentMessage: '', accountId: 0 });
  }

  handleTextArea = (e) => {
    // Handle both regular textarea and Ant Design Textarea
    const value = e && e.target ? e.target.value : e;
    this.setState({ commentMessage: value });
  }

  onOpenAddModal = () => {
    this.setState({ isAddModal: true, commentMessage: '', accountId: 0 });
  }

  onCloseAddModal = () => {
    this.setState({ isAddModal: false, commentMessage: '', accountId: 0 });
  }

  SaveNewInternalNote = () => {
    if (!this.state.commentMessage || this.state.commentMessage.trim() === '') {
      toast.error("Please enter a comment message");
      return;
    }

    const body = {
      CommentId: 0,
      Comments: this.state.commentMessage,
      CompanyId: this.state.companyId
    };

    //console.log("Saving Internal Note:", body);

    this.setState({ loading: true }, () => {
      this.props.InsertUpdateOtherInternalNotes(body);
      setTimeout(() => {
        toast.success("Notes added successfully.");
        this.setState({ isAddModal: false, commentMessage: '', accountId: 0 });
        this.getOtherInternalNotes();
      }, 1500);
    });
  }


  render() {

    return (
      <React.Fragment>

        {/* Dialog for Add Other Internal Notes */}
        <Dialog
          className="comment-Top-align"
          maxWidth="sm"
          fullWidth={true}
          open={this.state.isAddModal}
          onClose={() => this.onCloseAddModal()}
        >
          <React.Fragment>
            {/* Header with Title and Close Button */}
            <div className="Comments modal-header" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '16px' }}>
              <span className="log-history-title">Add Other Internal Notes</span>
              <Button className="jr-btn close-btn" onClick={() => this.onCloseAddModal()} style={{ padding: '0', minWidth: 'auto' }}>
                <ClearIcon />
              </Button>
            </div>

            <DialogContent>
              <div className="row">
                <div className="col-md-12">
                  <Textarea
                    placeholder="Enter your comment"
                    onChange={(e) => this.handleTextArea(e)}
                    value={this.state.commentMessage}
                    className="textarea-box"
                    style={{ border: "1px solid " + this.state.ColorCode }}
                  />
                </div>
              </div>

              <div className="add-comment-btn-box" style={{ marginTop: '20px' }}>
                <Button
                  className="add-comment-btn"
                  style={{
                    backgroundColor: this.state.ColorCode,
                    color: 'white',
                    opacity: (!this.state.commentMessage || this.state.commentMessage.trim() === '') ? 0.5 : 1,
                    cursor: (!this.state.commentMessage || this.state.commentMessage.trim() === '') ? 'not-allowed' : 'pointer'
                  }}
                  disabled={!this.state.commentMessage || this.state.commentMessage.trim() === ''}
                  onClick={() => this.SaveNewInternalNote()}
                >
                  Add Notes
                </Button>
              </div>
            </DialogContent>
          </React.Fragment>
        </Dialog>

        <div className="dashboardPage">
          <div className="page-heading page-title-box d-sm-flex justify-content-sm-between align-items-sm-center">
            <h2 className="title mb-3 mb-sm-0">{JSON.parse(localStorage.getItem('userData')) != null ? JSON.parse(localStorage.getItem('userData')).companyName : ""} | {LinkType.OtherInternalNotes}</h2>
          </div>

          <div className="padding-box app-wrapper">
            <div className="row">
              <div className="col-md-12">
                <div className="row">
                  {/* <div className="col-md-4">
                    <div style={{ display: "flex" }}>
                      <input type="text" className="form-control mr-2" placeholder="Search..." onChange={(e) => this.ChangeSearch(e)} />
                      <Button variant="contained" className=" jr-btn graycolor text-white refresh-btn" onClick={() => this.OnSearchClick()}>Search</Button>
                    </div>
                  </div> */}
                  <div className="col-md-10"></div>
                  {/* <div className="col-md-2">
                    <div className="checkbox pointer float-right" >
                      <div className="chiller_cb">
                        <input id="TFB" type="checkbox" onClick={(e) => this.onResolvedClick(e)} />
                        <label for="TFB">
                          <p className="checkbox-title">Show Resolved</p>
                          <p className="parag-text"></p>
                        </label>
                        <span></span>
                      </div>
                    </div>
                  </div> */}
                  <div className="col-md-2">
                    <div className="float-right">
                      <Button variant="contained" className=" jr-btn text-white greencolor refresh-btn" onClick={() => this.onOpenAddModal()}>Add Other Internal Notes</Button>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {this.state.loading ?
              <CircularProgress></CircularProgress>
              :

              <React.Fragment>
                <div className="table-responsive-material">
                  <table className="table tablebox account-reconcilliation">
                    <thead  >
                      <tr style={{ backgroundColor: this.state.ColorCode }}>
                        <th className="textCenter" style={{ width: "2%" }}>#/Icon</th>
                        <th className="td-width" style={{ width: "20%" }}>Account</th>
                        <th className="td-width">Internal Notes</th>

                        {/* <th className="td-width-90">
                          <label className="container101 header-check ">
                            {this.state.SelectALL ?
                              <input className="second-check-box" checked="checked" type="checkbox" onClick={(e) => this.SelectALL(e)} />
                              :
                              <input className="second-check-box" type="checkbox" onClick={(e) => this.SelectALL(e)} />
                            }
                            <span className="checkmark101 white_border greenMark "></span>
                          </label>
                        </th> */}

                      </tr>
                    </thead>
                    <tbody>
                      {(() => {
                        const isEmptyRow = this.state.QuesData && this.state.QuesData.length === 1 && (() => {
                          const item = this.state.QuesData[0];
                          return (
                            (!item.accountNumber || item.accountNumber.trim() === "") &&
                            (!item.accountName || item.accountName.trim() === "") &&
                            (!item.accountDescription || item.accountDescription.trim() === "") &&
                            (!item.commentMessage || item.commentMessage.trim() === "")
                          );
                        })();
                        if (isEmptyRow) {
                          return (
                            <tr>
                              <td className="text-center" colSpan="3">
                                <p style={{ padding: "20px" }}>No issues here! Keep up the good work!</p>
                              </td>
                            </tr>
                          );
                        }
                        return (this.state.QuesData && this.state.QuesData.length > 0) && this.state.QuesData.map((item, j) => (
                        <React.Fragment key={j}>
                          {<tr onClick={() => this.isExpand(j, item)}>
                            <td style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                              {/* Page Number */}
                              {this.state.PageNo === 1 ? j + 1 : (this.state.PageNo - 1) * this.state.PageSize + (j + 1)}

                              {/* Badge */}
                              {item.accountId > 0 && (() => {
                                const acct = (item.accountType || "").trim().toLowerCase();
                                const isIS = ["income", "other income", "expense", "other expense"].includes(acct);

                                const badgeStyle = isIS
                                  ? { backgroundColor: "green", color: "white" }
                                  : { backgroundColor: "#1976d2", color: "white" };

                                const badgeLabel = isIS ? "IS" : "BS";

                                return (
                                  <span
                                    style={{
                                      width: "24px",
                                      height: "24px",
                                      display: "flex",
                                      justifyContent: "center",
                                      alignItems: "center",
                                      borderRadius: "50%",
                                      fontSize: "12px",
                                      fontWeight: "bold",
                                      ...badgeStyle
                                    }}
                                  >
                                    {badgeLabel}
                                  </span>
                                );
                              })()}
                            </td>

                            <td>
                              {(() => {
                                const accNum = item.accountNumber || "";
                                const accName = item.accountName || "";
                                return (accNum + " " + accName).trim() ? (accNum + " " + accName).trim() : "";
                              })()}
                            </td>
                            <td>
                              {(() => {
                                const description = item.accountDescription || "";
                                const message = item.commentMessage || "";

                                if (!description && !message) return "";
                                if (!description) return message;
                                if (!message) return description;
                                return (
                                  <>
                                    <b>{description} : </b>
                                    {message}
                                  </>
                                );
                              })()}
                            </td>

                          </tr>}


                          {/* Used for edit the Internal Notes */}
                          {this.state.editIndex === j &&
                            <React.Fragment>
                              <tr className="editRowColor">
                                <td colSpan="3">
                                  <div className="row">
                                    <div className="col-md-10">
                                      <div className="row">
                                        <div className="col-md-2">
                                          <label className="input-title">Internal Notes:</label>
                                        </div>
                                        <div className="col-md-10">
                                          <Textarea className="placheholder-color"
                                            value={this.state.commentMessage} name="commentMessage"
                                            style={{ 'lineHeight': '30px', width: '100%', border: 'none', resize: 'none', padding: '6px', paddingLeft: '10px', borderRadius: '3px', border: '1px solid #ccc', overflow: 'hidden' }}
                                            resize={"false"} placeholder=""
                                            onChange={(e) => this.handleTextArea(e)} />
                                        </div>
                                      </div>
                                    </div>

                                    <div className="col-md-2">
                                      <Button variant="contained" className="jr-btn jr-btn-sm bg-teal text-white" onClick={() => this.UpdateInternalNote(item)}>SAVE</Button>
                                      <Button variant="contained" className="jr-btn jr-btn-sm bg-danger text-white" onClick={() => this.onRowCancelClick()}>CANCEL</Button>
                                    </div>
                                  </div>
                                </td>
                              </tr>
                            </React.Fragment>
                          }
                        </React.Fragment>
                        ));
                      })()}

                      {this.state.QuesData === null || this.state.QuesData.length === 0 ?
                        <tr>
                          <td className="text-center" colSpan="2">
                            No issues here! Keep up the good work!
                          </td>
                        </tr>
                        : ""}
                    </tbody>
                  </table>
                </div>
                <PaginationComponent
                  selectedPageNo={this.state.PageNo}
                  selectedSize={this.state.PageSize}
                  TotalRecords={this.state.TotalRecords}
                  ChangePageSize={this.ChangePageSize}
                  ChangePage={this.ChangePage}
                  CurrentRecords={this.state.QuesData.length}
                >
                </PaginationComponent>
              </React.Fragment>
            }
          </div>
        </div>
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    OtherInternalNotesData: state.QuestionCommentsData.OtherInternalNotesData
  }
}

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({
    GetOtherInternalNotes,
    UpdateAccountsCommentNotes,
    AddQuestion,
    InsertUpdateOtherInternalNotes
  }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(OtherInternalNotes);
